<template>
  <div>
    <div
      style="
        background: linear-gradient(90deg, #2e599f 0, #4273b5 100%);
        height: 120px;
        z-index: 1004;
        padding-top: 0;
      "
    >
      <div class="inner home-inner" style="max-width: 1184px; margin: 0 auto">
        <img
          src="@/assets/image/zhaopin.png"
          style="float: left; height: 100px; margin: 10px 35px 0px 35px"
        />
        <div style="font-size: 0; float: right; position: relative; margin-right: 8rem">
          <form
            action="/wapi/zppassport/login/phone"
            method="post"
            data-reload="true"
            ka="signup_g_index_done"
            style="padding: 0; margin: 0; -webkit-tap-highlight-color: "
          >
            <input type="hidden" name="regionCode" value="+86" />
            <img
              src="https://static.zhipin.com/v2/web/geek/images/fast-reg-text.png"
              style="height: 36px; margin: 22px 0 8px 0"
            />
          </form>
        </div>
        <div style="font-size: 16px; color: #fff; padding-top: 28px"></div>
      </div>
    </div>

    <div class="lastest" style="padding-bottom: 0px; padding-top: 20px">
      <div class="juzhong">
        <div class="lastest_news">
          <div
            class="index_news_list"
            style="width: 33%; height: 410px; margin-bottom: 110px"
          >
            <div class="fd_1a" id="xwdt">
              <h3>
                <ul>
                  <li
                    style="cursor: pointer"
                    v-for="(item, index) in titleList"
                    :key="index"
                    @click="titleTagChange(item)"
                    :class="item.id == titleTag ? 'cur' : ''"
                  >
                    {{ item.name }}
                  </li>
                  <!-- <li>通知公告</li> -->
                </ul>
                <div class="last" id="1amore" v-if="titleTag != 'qyjj'">
                  <router-link
                    :to="{
                      path: '/newsList',
                      query: {
                        categoryId: titleTag == 'tzgg' ? 1 : 5,
                      },
                    }"
                    >+更多</router-link
                  >
                </div>
              </h3>
              <div
                v-if="titleTag == 'qyjj'"
                style="
                  text-indent: 40px;
                  line-height: 38px;
                  font-size: 17px;
                  width: 350px;
                "
              >
                石家庄市国经人力资源管理有限公司（Shijiazhuang Talent
                Group）是石家庄市国资委、市国投集团所属综合型人力资源服务机构。
                公司围绕“搭建政府平台，服务地方经济，稳健规范运营，塑造特色品牌”的经营宗旨，
                肩负着石家庄城市HR和打造知名人才高地重要抓手的使命，服务于石家庄市不断优化的人才生态系统，
                持续提升城市对人才的吸引力，激发人才的创新创业活力，为推动经济总量过万亿、实现弯道超车，
                加快建设现代化、国际化美丽省会城市提供了人才保障和智力支撑。
              </div>
              <div v-if="titleTag == 'qyjj'" style="text-indent: 30px; display: none">
                公司拥有一支由高学历、高素质人才 组成的创业团队，现有员工11名，均为
                本科以上学历。其中全日制研究生两名， 中级以上职称6人。30岁以下8人，团队
                成员年轻而充满朝气，具有创新意识并 勇于迎接挑战。都具有人力资源专业多
                年从业经验，同时具备良好的社会责任 感，愿为人力资源事业贡献一己之力。
              </div>

              <div class="conts" id="GroupNews" v-if="titleTag == 'tzgg'">
                <ul class="d_1au cont cur">
                  <li v-for="(item, index) in groupNews" :key="index">
                    <router-link
                      :to="{
                        path: '/newsDetail',
                        query: { id: item.id },
                      }"
                      ><i>{{ item.title }}</i
                      ><span>{{ item.publishTime }}</span></router-link
                    >
                  </li>
                </ul>
              </div>
              <div class="conts" id="GroupNews" v-if="titleTag == 'lytz'">
                <ul class="d_1au cont cur">
                  <li v-for="(item, index) in noticeNews" :key="index">
                    <router-link
                      :to="{
                        path: '/newsDetail',
                        query: { id: item.id },
                      }"
                      ><i>{{ item.title }}</i
                      ><span>{{ item.publishTime }}</span></router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="fd_1" id="PicNews"> -->
        <!-- 轮播图 -->
        <div
          class="swiper-container"
          style="
            width: 67%;
            margin-top: 3rem;
            height: 500px;
            float: right;
            margin-bottom: 4rem;
          "
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in bannerList"
              :key="index"
              @click="goDetail(item)"
            >
              <img :src="item.advUrl" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!--<div class="box_head" style="
        width: 100%;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
      ">
      <div class="red_block" style="
          width: 10px;
          height: 30px;
          margin-right: 20px;
          background-color: rgb(66, 115, 181);
        "></div>
      <span class="title" style="font-size: 20px; width: 90px; font-weight: 700">服务模块</span>
      <div class="line" style="
          width: calc(100% - 160px);
          margin-right: 0px;
          height: 1px;
          background-color: rgb(204, 204, 204);
          margin-left: 25px;
        "></div>
    </div>-->

    <!-- <div class="home_xwzx_left"> -->
    <!-- <div class="home_job">
        <ul class="home_job_centent" style="margin-top:30px">
          <li
            class="home_job_first"
            :class="item.id == jianjieInfo.id ? 'cur_jianjie' : ''"
            v-for="(item, index) in jianjieList"
            :key="index"
            @click="showJianjie(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="home_xwzx_content">
        <img :src="jianjieInfo.imgUrl" style="width: 100%; height: 100%" />
      </div> -->

    <!--<div class="service_content">
      <div class="service_title">
        <div class="service_box">
          <div>
            <span class="span01">国经</span>
            <span>人力资源</span>
          </div>
        </div>
      </div>
      <div class="service_list">
        <div class="service_num" style="width: 150px">
          <div class="num_box">
            <div class="num_bg" @mouseover="hover.one = true" @mouseleave="hover.one = false">
              01
            </div>
            <div class="dot"></div>
          </div>
          <div class="num_con" @mouseover="hover.one = true" @mouseleave="hover.one = false"
               :class="{ show: hover.one }">
            <div class="num_title">人才招聘</div>
            <div class="num_nr" style="width: 180%">
              *代理招聘：一线基础岗位批量招聘<br />
              *V聘会：一个企业多个岗位专场招聘<br />
              *Offer派：同一岗位多个企业同场招聘<br />
              *校招：全国高校校招全流程服务。
            </div>
          </div>
        </div>
        <div class="service_num">
          <div class="num_box">
            <div class="num_bg" @mouseover="hover.two = true" @mouseleave="hover.two = false">
              02
            </div>
            <div class="dot"></div>
          </div>
          <div class="num_con" @mouseover="hover.two = true" @mouseleave="hover.two = false"
               :class="{ show: hover.two }">
            <div class="num_title">国企培训</div>
            <div class="num_nr">
              *定制化企业培训服务<br />
              *体验式培训<br />
              *红色教育<br />
              *标杆企业参访
            </div>
          </div>
        </div>
        <div class="service_num">
          <div class="num_box">
            <div class="num_bg">03</div>
            <div class="dot"></div>
          </div>
          <div class="num_con" @mouseover="hover.three = true" @mouseleave="hover.three = false"
               :class="{ show: hover.three }">
            <div class="num_title">人力资源外包</div>
            <div class="num_nr" style="width: 125%">
              *降低税负<br />
              *合法合规<br />
              *高效省时<br />
              *针对行业我特性<br />
              *提供垂直解决方案
            </div>
          </div>
        </div>
        <div class="service_num">
          <div class="num_box">
            <div class="num_bg">04</div>
            <div class="dot"></div>
          </div>
          <div class="num_con" @mouseover="hover.four = true" @mouseleave="hover.four = false"
               :class="{ show: hover.four }">
            <div class="num_title">人力咨询</div>
            <div class="num_nr">
              *企业岗位优化设计<br />
              *企业人员资源规划制定<br />
              *薪酬管理体系/绩效管理体系<br />
              *人力资源全面诊断分析<br />
              *岗位胜任能力模型<br />
              *员工激励方案设计
            </div>
          </div>
        </div>
        <div class="service_num">
          <div class="num_box">
            <div class="num_bg">05</div>
            <div class="dot"></div>
          </div>
          <div class="num_con" @mouseover="hover.five = true" @mouseleave="hover.five = false"
               :class="{ show: hover.five }">
            <div class="num_title">劳务派遣</div>
            <div class="num_nr">
              *解决编制问题<br />
              *允许弹性用工<br />
              *规避劳动争议<br />
              *降低管理成本
            </div>
          </div>
        </div>
        <div class="service_num">
          <div class="num_box">
            <div class="num_bg">06</div>
            <div class="dot"></div>
          </div>
          <div class="num_con" @mouseover="hover.six = true" @mouseleave="hover.six = false"
               :class="{ show: hover.six }">
            <div class="num_title">人才基地</div>
            <div class="num_nr">
              *高端人才寻访<br />
              *人才测评<br />
              *人才背景调查<br />
              *数字化人才发展中心
            </div>
          </div>
        </div>
        <div class="service_num">
          <div class="num_box">
            <div class="num_bg">07</div>
            <div class="dot"></div>
          </div>
          <div class="num_con" @mouseover="hover.seven = true" @mouseleave="hover.seven = false"
               :class="{ show: hover.seven }">
            <div class="num_title">留学服务</div>
            <div class="num_nr" style="width: 145%">
              *经验丰富的留学顾问<br />
              *专业的身份证申请团队<br />
              *出国前准备一站式服务<br />
              *完善的后续服务
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <!-- </div> -->

    <section class="section_xwzx">
      <div class="inner" id="hdzqgl">
        <div
          class="hdzqgl_img"
          style="width: 96%; margin: 0px auto"
          v-for="(item, index) in middleImageList"
          :key="index"
          @click="goDetail(item)"
        >
          <img
            class="hdzqgl_img_style"
            :src="item.advUrl"
            alt=""
            style="margin-top: 5px"
          />
        </div>
      </div>
    </section>
    <div
      style="
        width: 95%;
        margin: 32px auto;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin-bottom: 0;
      "
    >
      <div
        class="box_head"
        style="width: 100%; display: flex; -webkit-box-align: center; align-items: center"
      >
        <div
          class="red_block"
          style="width: 10px; height: 30px; margin-right: 20px; background-color: #4273b5"
        ></div>
        <span class="title" style="font-size: 20px; width: 90px; font-weight: 700"
          >热门岗位</span
        >
        <div
          class="line"
          style="
            width: calc(100% - 160px);
            margin-right: 0;
            height: 1px;
            background-color: #ccc;
            margin-left: 25px;
          "
        ></div>
      </div>
      <div
        class="home_rmzw_block mz-sk-.home_rmzw_block-clone mz-sk-transparent mz-sk-pseudo mz-sk-pseudo-circle"
      >
        <div
          class="home_rmzw_box"
          v-for="(item, index) in hotPostList"
          :key="index"
          @click="goBaoming(item)"
        >
          <div class="rmzw_info">
            <!-- <div class="rmzw_info_img">
            <img
              src=""
              alt=""
            />
          </div> -->
            <span class="rmzw_job">{{ item.name }}</span>
          </div>
          <p class="home_rmzw_salary">薪资:{{ item.salary }}</p>
          <div class="home_rmzw_centent">
            <p>
              {{ item.education }}
              | {{ item.majorDemand }} |
              {{ item.age }}
            </p>
            <p>{{ item.unit }}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        width: 95%;
        margin: 32px auto;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin-bottom: 0;
      "
    >
      <div
        class="box_head"
        style="width: 100%; display: flex; -webkit-box-align: center; align-items: center"
      >
        <div
          class="red_block"
          style="width: 10px; height: 30px; margin-right: 20px; background-color: #4273b5"
        ></div>
        <span class="title" style="font-size: 20px; width: 90px; font-weight: 700"
          >企业推荐</span
        >
        <div
          class="line"
          style="
            width: calc(100% - 160px);
            margin-right: 0;
            height: 1px;
            background-color: #ccc;
            margin-left: 25px;
          "
        ></div>
      </div>
      <div class="bk_little_module1" v-for="(item, index) in companyList" :key="index">
        <div class="bk_little_module_left">
          <div class="special_img_box">
            <div class="special_img" :class="item._class ? item._class : ''">
              <img :src="item.companyLogo" style="width: 100%" />
            </div>
          </div>
          <div class="special_title" style="font-size: 16px !important">
            {{ item.name }}
          </div>
        </div>
        <div class="special_content">
          <div style="width: 100%; font-size: 16px !important">
            {{ item.introduce }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
  data() {
    return {
      groupNews: [],
      noticeNews: [],
      showLoginBtn: false,
      authentication: "",
      bannerList: [],
      middleImageList: [],
      titleList: [
        { id: "qyjj", name: "企业简介" },
        { id: "tzgg", name: "通知公告" },
        { id: "lytz", name: "录用通知" },
      ],
      titleTag: "qyjj",
      hotPostList: [],
      companyList: [
        {
          name: "石家庄国控城市发展投资集团有限责任公司",
          _class: "guokonglogo",
          introduce:
            "城发投集团定位为我市城市更新实施和土地一级开发主体，城市投资、建设、运营一体化主体。主要业务范围包括城市更新，土地一级开发，城市基础设施的投资、建设和运营管理，片区综合开发和运营管理，房地产开发，商业项目开发运营，规划设计、施工建造等工程全产业链服务，市政公用事业经营，资产运营，停车场建设运营，户外广告经营等。",
        },
        {
          name: "石家庄交通投资发展集团有限责任公司",
          _class: "jiaotoulogo",
          introduce:
            " 交投集团定位为我市综合交通产业投资、建设、运营主体。主要业务范围包括我市公路、高速公路、轨道交通等主要交通基础设施及配套设施项目的投融资、开发建设和运营管理，勘察设计、施工、检测、监理等交通建设全产业链服务，交通沿线土地综合开发，公交运营，物流运输等。",
        },
        {
          name: "石家庄国有资本投资运营集团有限责任公司",
          _class: "guotoulogo",
          introduce:
            " 国投集团定位为我市国有资本投资运营主体，主要承担我市国有资本运营管理、重大战略性产业投资、实业经营、金融和类金融服务。主要业务范围包括授权范围内的国有资产管理，低效无效资产处置，政府主导产业发展基金等基金运作，新一代电子信息产业、生物医药产业、先进装备制造业等产业的投资、培育、引导，新能源汽车等产业投资发展，智慧城市建设和数字产业投资发展，金融和类金融服务，实业经营，商贸物流服务，纺织，软件开发、服务、销售等。",
        },
        {
          name: "石家庄水务投资集团有限责任公司",
          _class: "shuitoulogo",
          introduce:
            " 水投集团定位为我市水务、农业领域国有资本投资公司，市政府授权特许经营城市涉水事务的国有企业。主要业务范围包括自来水的生产、销售，污水处理及再生水利用，水系综合整治，水利工程施工，水系沿线土地综合开发，现代农业等。",
        },
        {
          name: "石家庄文化旅游投资集团有限责任公司",
          _class: "lvtoulogo",
          introduce:
            " 旅投集团定位为全市文旅产业投资、建设、运营主体。主要业务范围包括全市国有旅游、体育、文化产业资源整合、开发、经营管理，文化旅游项目及配套基础设施项目的投融资、建设、管理和运营，休闲康养服务，会展、文化艺术体育活动策划、服务和经营，文化旅游商品开发生产营销，文旅品牌宣传推广，酒店运营管理，体育场馆、会展场馆运营管理等。",
        },
        {
          name: "石家庄常山纺织集团有限责任公司",
          _class: "changshanlogo",
          introduce:
            " 常山集团主要业务范围包括纺织、软件和资本运营三大业务板块，位列中国制造企业500强、中国棉纺织行业主营业务收入百强企业第20位、中国棉纺织行业竞争力百强企业第22位、河北省百强企业第54位、石家庄市百强企业第13位，荣获河北省行业龙头型领军企业、全国纺织行业党建工作先进企业等称号。",
        },
        {
          name: "石家庄北国人百集团有限责任公司",
          _class: "beirenlogo",
          introduce:
            " 北人集团主要业务范围包括购物中心、文旅娱乐、社区商业综合体、物流服务、电商经济、百货/超市/电器/珠宝专业店、餐饮服务、会展服务、地产等多个领域，位列2020年中国连锁百强榜单第26位、2020年中国零售百强第33位、2020年中国服务业企业500强第265位，荣获全国商业服务业年度十佳企业、全国和谐商业企业、全国商业服务业顾客满意企业、全国文明单位等称号。",
        },
      ],
      jianjieList: [
        {
          name: "人才招聘",
          id: 1,
          imgUrl: require("@/assets/jianjie/rczp.png"),
        },
        {
          name: "国企培训",
          id: 2,
          imgUrl: require("@/assets/jianjie/gqpx.png"),
        },

        {
          name: "人力资源外包",
          id: 4,
          imgUrl: require("@/assets/jianjie/zywb.png"),
        },
        {
          name: "人力咨询",
          id: 3,
          imgUrl: require("@/assets/jianjie/rlzx.png"),
        },
        {
          name: "劳务派遣",
          id: 5,
          imgUrl: require("@/assets/jianjie/lwpq.jpg"),
        },
        {
          name: "人才基地",
          id: 6,
          imgUrl: require("@/assets/jianjie/lt.png"),
        },
        {
          name: "留学服务",
          id: 7,
          imgUrl: require("@/assets/jianjie/bpo.png"),
        },
      ],
      jianjieInfo: {
        id: 1,
        imgUrl: require("@/assets/jianjie/rczp.png"),
      },
      hover: {
        one: false,
        two: false,
        three: false,
        four: false,
        five: false,
        six: false,
        seven: false,
      },
    };
  },
  filters: {
    weekday(val) {
      let title;
      if (val == 0) {
        title = "星期日";
      } else if (val == 1) {
        title = "星期一";
      } else if (val == 2) {
        title = "星期二";
      } else if (val == 3) {
        title = "星期三";
      } else if (val == 4) {
        title = "星期四";
      } else if (val == 5) {
        title = "星期五";
      } else if (val == 6) {
        title = "星期六";
      }
      return title;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
    let href = window.location.href;
    if (href.indexOf("bsh_bid") > 0 || href.indexOf("courseDeatil") > 0) {
      let url = href.substring(href.indexOf("?") + 1, href.indexOf("&"));
      let urlArr = url.split("=");
      window.location.href =
        "http://" + window.location.host + "/#/" + urlArr[0] + "?id=" + urlArr[1];
    }
  },

  created() {
    this.getNewList();
    this.getNoticeList();
    this.getBannerList();
    this.getMiddleList();
    this.getHotPostList();
    // this.getCompanyList();
    this.authentication = this.$cookies.get(this.$commons.User.Authentication);
  },
  methods: {
    titleTagChange(item) {
      let _this = this;
      _this.titleTag = item.id;
    },
    goDetail(item) {
      console.log("item", item);
      let _this = this;
      if (item.sourceType == 3) {
        _this.$router.push({
          path: "/newsDetail",
          query: { id: item.linkUrl },
        });
      } else if (item.sourceType == 2) {
        _this.$router.push({
          path: "/recruitDetail",
          query: { id: item.linkUrl },
        });
      } else if (item.sourceType == 1) {
        window.open(item.linkUrl, "_blank");
      }
    },
    getNewList() {
      let _this = this;
      let parmas = {
        pageNum: 1,
        pageSize: 7,
        categoryId: 1,
      };
      _this.$api.news
        .articleList(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.groupNews = res.rows;
          }
        })
        .catch(() => {});
    },
    getNoticeList() {
      let _this = this;
      let parmas = {
        pageNum: 1,
        pageSize: 7,
        categoryId: 5,
      };
      _this.$api.news
        .articleList(parmas)
        .then((res) => {
          console.log(res);
          if (res.code == _this.$commons.RespCode.success) {
            _this.noticeNews = res.rows;
          }
        })
        .catch(() => {});
    },
    getBannerList() {
      let _this = this;
      let parmas = {
        pageNum: 1,
        pageSize: 8,
        advZoneId: 1,
        status: 1,
      };
      _this.$api.advertisement
        .list(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.bannerList = res.rows;
            _this.$nextTick(function () {
              new Swiper(".swiper-container", {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                },
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              });
            });
          }
        })
        .catch(() => {});
    },
    getMiddleList() {
      let _this = this;
      let parmas = {
        pageNum: 1,
        pageSize: 8,
        advZoneId: 2,
        status: 1,
      };
      _this.$api.advertisement
        .list(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.middleImageList = res.rows;
          }
          console.log(res, 11111111);
        })
        .catch(() => {});
    },
    getHotPostList() {
      let _this = this;
      let parmas = {
        pageNum: 1,
        pageSize: 8,
        hot: 1,
      };
      _this.$api.post
        .getList(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.hotPostList = res.rows;
            console.log("hotPostList", _this.hotPostList);
          }
        })
        .catch(() => {});
    },
    getCompanyList() {
      let _this = this;
      _this.$api.company
        .getCompanyList()
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            if (res.rows.length > 0) {
              _this.companyList = res.rows;
            }
          }
        })
        .catch(() => {});
    },
    goBaoming(item) {
      this.$router.push({
        path: "/recruitDetail",
        query: { id: item.noticeId },
      });
    },
    getDate() {
      var aData = new Date();
      this.nowDate =
        aData.getFullYear() +
        "年" +
        (aData.getMonth() + 1) +
        "月" +
        aData.getDate() +
        "日";
      this.weekday = aData.getDay();
    },
    scrollToTop() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 500) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    },
    goTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },

    kefu() {
      let _this = this;
      window.open("http://wpa.qq.com/msgrd?v=3&uin=12345645&site=qq&menu=yes");
    },
    showJianjie(item) {
      let _this = this;
      _this.jianjieInfo = item;
    },
  },
};
</script>

<style scoped>
.course-type span {
  cursor: pointer;
}

.notice_detail_title {
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  margin-top: 10px;
}

.notice_detail_time {
  margin-top: 12px;
  text-align: center;
}

.notice_detail_content {
  margin-top: 10px;
}

.fd_1a h3 ul li {
  width: 100px;
  float: left;
  font-size: 16px;
  text-align: center;
  position: relative;
  letter-spacing: 2px;
}

.hdzqgl_img {
  width: 100%;
  margin: 20px 0;
  cursor: pointer;
}

.hdzqgl_img img {
  width: 100%;
}

.home_rmzw_block {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}

.home_rmzw_box {
  width: 24%;
  margin-bottom: 30px;
  cursor: pointer;
  box-shadow: 0px 1px 10px rgb(208 214 226 / 62%);
  border-radius: 10px;
  padding: 0 5px 0 10px;
  background: #f6faff;
}

.rmzw_info {
  display: flex;
  align-items: center;
  height: 60px;
}

.home_rmzw_salary {
  height: 24px;
  font-size: 24px;
  font-weight: bold;
  line-height: 29px;
  color: #f04d2a;
  margin-top: 10px;
}

.home_rmzw_centent {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 400;
  line-height: 27px;
  color: #666666;
  letter-spacing: 1px;
}

.home_rmzw_centent > p {
  margin-top: 5px;
  line-height: 24px;
}

.rmzw_info_img {
  width: 60px;
  height: 60px;
  /* height: 60px; */
  margin-right: 10px;
  /* background: #FFFFFF; */
  border: 1px solid #ebebeb;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px;
}

.rmzw_info_img img {
  width: 100%;
  height: auto;
  max-height: 100%;
}

.rmzw_info span {
  /* height: 60px; */
  font-size: 24px;
  font-weight: bold;
  line-height: 30px;
  color: #333333;
  /* width: 194px; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.home_job_first:hover {
  /* background: #4CAFF7; */
  background: #3664a8;
  color: #ffffff;
}

.cur_jianjie {
  background: #3664a8;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue